var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 7,
    fill: "#F4F2FE",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22118 11.6221C9.38451 11.3073 9.71427 11.0896 10.0899 11.0896H25.9101C26.2857 11.0896 26.6155 11.3073 26.7788 11.6221L18 17.7673L9.22118 11.6221ZM7.11245 12.049C7.11228 12.059 7.11226 12.0689 7.11239 12.0789V23.9323C7.11239 25.5722 8.44999 26.9098 10.0899 26.9098H25.9101C27.55 26.9098 28.8876 25.5722 28.8876 23.9323V12.0789C28.8877 12.0689 28.8877 12.059 28.8876 12.049C28.8777 10.4173 27.544 9.0896 25.9101 9.0896H10.0899C8.45604 9.0896 7.12226 10.4174 7.11245 12.049ZM26.8876 13.9873V23.9323C26.8876 24.4676 26.4454 24.9098 25.9101 24.9098H10.0899C9.55456 24.9098 9.11239 24.4676 9.11239 23.9323V13.9873L17.4265 19.8072C17.7709 20.0482 18.2291 20.0482 18.5735 19.8072L26.8876 13.9873Z",
    fill: "url(#paint0_linear_81_840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_840",
    x1: 26.4133,
    y1: 9.0896,
    x2: 8.59309,
    y2: 26.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8764FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A92FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.184798fafa7a4e12c235834aa72b778b.svg";
export { ForwardRef as ReactComponent };